module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-5.38f47819.webp";